import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minLengthIfNotEmpty(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = (control.value ?? '').toString();

    // Truly blank (empty or only spaces) = show all
    if (raw.trim().length === 0) {
      return null;
    }

    // Wildcards and spaces don't count toward the minimum
    const significant = raw.replace(/[*%\s]/g, '');

    return significant.length >= min ? null : { minLengthIfNotEmpty: true };
  };
}
